import { render, staticRenderFns } from "./PageView.vue?vue&type=template&id=16b38beb&scoped=true&"
import script from "./PageView.vue?vue&type=script&lang=js&"
export * from "./PageView.vue?vue&type=script&lang=js&"
import style0 from "./PageView.vue?vue&type=style&index=0&id=16b38beb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b38beb",
  null
  
)

export default component.exports